import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import {
  DotsThreeVerticalIcon,
  PencilSimpleLineIcon,
  TrashIcon
} from "@phosphor-icons/react";
import Icon from "components/Icon/Icon";
import { RowActionsMenuWrapper } from "./styled";

const MENU_WIDTH = 142;

const RowActionsMenu = ({ onEdit, onRemove }) => {
  const [open, setOpen] = useState(false);
  const [ready, setReady] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  // Open menu with position calculated first (NO JERK)
  const handleOpen = () => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();

    setPosition({
      top: rect.bottom + window.scrollY + 0,
      left: rect.right + window.scrollX - MENU_WIDTH
    });

    setReady(true);
    setOpen(true);
  };

  // Close helper
  const closeMenu = () => {
    setOpen(false);
    setReady(false);
  };

  // Outside click close
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !triggerRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <>
      {/* Trigger (inside table) */}
      <div
        ref={triggerRef}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "10px"
        }}
      >
        <Icon
          component={DotsThreeVerticalIcon}
          size={20}
          onClick={handleOpen}
        />
      </div>

      {/* Portal Menu */}
      {open &&
        ready &&
        ReactDOM.createPortal(
          <RowActionsMenuWrapper
            ref={menuRef}
            className="row-action-menu"
            style={{
              position: "absolute",
              top: position.top,
              left: position.left
            }}
          >
            <div
              className="menu-item"
              onClick={() => {
                onEdit();
                closeMenu();
              }}
            >
              <Icon component={PencilSimpleLineIcon} size={14} />
              Update Details
            </div>

            <div
              className="menu-item danger"
              onClick={() => {
                onRemove();
                closeMenu();
              }}
            >
              <Icon component={TrashIcon} size={14} />
              Remove Member
            </div>
          </RowActionsMenuWrapper>,
          document.body
        )}
    </>
  );
};

export default RowActionsMenu;
